import React from "react";
import { Container, Row, Col, Button, Modal, InputGroup, Form, FormControl, Card, Accordion } from 'react-bootstrap';

import ChainJobConfigViewModel from "./ChainJobConfig.viewmodel"
import { FaFileExport, FaPlusCircle, FaSearch } from "react-icons/fa";
import ChainJobConfigTable from "./components/ChainJobConfigTable";
import { ChainJobConfigAddModal } from "./components/ChainJobConfigAddModal";

export default function ChainJobConfigView() {
    const {
        isShowModal,
        companyMaster,
        chainJobResponse,

        fetchChainJob,
        handleActionModal,
        handleCreateChainJob,
        handleChangeSearchHelp
    } = ChainJobConfigViewModel();

    return (
        <Container>
            <Row>
                <Col>
                    <div className="master-data-content">
                        <div className='trapezoid-head' style={{ width: '200px', zIndex: 1 }}>
                            <span>
                                Job config
                            </span>
                        </div>
                        <div className="mat-box shadow p-3 mb-5 bg-white rounded">
                            <Col>
                                <Row>
                                    <Col>
                                        <div className='trapezoid trapezoid-purple' style={{ width: '200px', display: 'inline-block' }}>
                                            <span>
                                                <i className="fa fa-search" aria-hidden="true"></i>
                                                Search menu
                                            </span>
                                        </div>
                                        <div className="mat-box shadow p-3 mb-5 bg-white rounded">
                                            <Row>
                                                <Col sm={4}>
                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <Form.Label>Company Code :</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            size='sm'
                                                            onChange={(e) => handleChangeSearchHelp("companyCode", e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={4}>
                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <Form.Label>Chain Job ID :</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            size='sm'
                                                            onChange={(e) => handleChangeSearchHelp("chainJobId", e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={4}>
                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <Form.Label>Chain Job Name :</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            size='sm'
                                                            onChange={(e) => handleChangeSearchHelp("chainJobName", e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={{ span: 2, offset: 10 }}>
                                                    <div className="mb-3 w-100 mt-4 d-flex justify-content-end">
                                                        <Button variant="info" size="sm" className="mx-1 btn btn-block" onClick={fetchChainJob}><FaSearch /> Search</Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div style={{ display: 'inline-block', float: 'right' }}>
                                            <Button
                                                variant="success"
                                                size="sm"
                                                className="mr-4"
                                            >
                                                <FaFileExport />
                                                &nbsp; Export Excel
                                            </Button>
                                            <Button variant="primary" size="sm">
                                                <FaPlusCircle />
                                                &nbsp; Create From Template
                                            </Button>
                                            <Button variant="info" size="sm" className="mx-1" onClick={() => handleActionModal(true)}>
                                                <FaPlusCircle />
                                                &nbsp;Add Chain Job Config
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Row className="mt-3">
                                <Col>
                                    {chainJobResponse &&
                                        <ChainJobConfigTable chainjobList={chainJobResponse} />
                                    }
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row >
            <ChainJobConfigAddModal isOpen={isShowModal} onClose={handleActionModal} onClickCreate={handleCreateChainJob} companyMaster={companyMaster!} />
        </Container>
    );
}